import { render, staticRenderFns } from "./RoomCountPicker.vue?vue&type=template&id=08fed8ec&scoped=true"
import script from "./RoomCountPicker.vue?vue&type=script&lang=js"
export * from "./RoomCountPicker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08fed8ec",
  null
  
)

export default component.exports